import { IProduct } from '@entities/product';
import type { FetchLoaderType } from '@shared/lib/routing';
import { ISeoPage } from '@widgets/seoPage';
import globalStore from 'modules/global-store';

type Params = {
  city: string;
  menu: string;
  product: string;
};

export const ProductSinglePageLoader = async (
  fetch: FetchLoaderType,
  { params, lang }: { params: Params; lang: string },
  { store }: { store: typeof globalStore },
) => {
  const { city, menu, product: productTextId } = params;

  const setSuperProductComponents = async (
    product: IProduct,
    currentProducts: IProduct[],
  ) => {
    // Find only missing toppings that need to be fetched
    const toppingsToFetch = product.toppings.filter(
      (id) => !currentProducts[id],
    );

    if (!toppingsToFetch.length) return [];
    // Fetch missing toppings in a single batch request
    const response = await fetch<{ product: IProduct[] }>({
      url: '/product/index',
      params: { city, lang, id: toppingsToFetch },
    });

    return response.data.product;
  };
  const fetchMonthProduct = async () => {
    const response = await fetch<{ products: IProduct[] }>({
      url: '/product/get_products_month',
      params: { city, lang },
    });
    const productMonth =
      response.data.products.find((p) => p.product_month) || null;
    return { data: { product: productMonth } };
  };
  const fetchProduct = () => {
    const isMonthRoll = productTextId === 'roll-mesyaca';
    return isMonthRoll
      ? fetchMonthProduct()
      : fetch<{ product: IProduct | null }>({
          url: '/product/index',
          params: { city, lang, text_id: productTextId },
        });
  };
  const [productResponse, seoPage] = await Promise.all([
    fetchProduct(),
    fetch<ISeoPage>({
      url: '/seo/page',
      params: { url: `/menu/${menu}/${productTextId}`, city, lang },
    }),
  ]);
  const productData = productResponse.data.product;
  if (productData?.product_type?.name === 'supercard') {
    const currentProducts = store.get('products') ?? {};
    const currentProductChunks = await setSuperProductComponents(
      productData,
      currentProducts,
    );
    store.set('products', {
      ...currentProducts,
      ...Object.fromEntries(
        currentProductChunks.map((prod) => [prod.id, prod]),
      ),
    });
  }
  const products = store.get('products');
  const specialStyle = productData && products?.[productData.id]?.specialStyle;

  return {
    seoPageData: seoPage.data,
    productData: specialStyle ? { ...productData, specialStyle } : productData,
  };
};
